var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import useEmblaCarousel from 'embla-carousel-react';
import { memo } from 'react';
import { twMerge } from 'tailwind-merge';
export const CarouselRoot = memo((props) => {
    const { children } = props, rest = __rest(props, ["children"]);
    const [emblaRef] = useEmblaCarousel(rest);
    return (<div className="embla overflow-auto" ref={emblaRef}>
			{children}
		</div>);
});
export const CarouselContainer = memo((_a) => {
    var { className } = _a, props = __rest(_a, ["className"]);
    return (<div className={twMerge(className, 'embla__container')} {...props}/>);
});
export const Root = CarouselRoot;
export const Container = CarouselContainer;
